import { useQuery } from '@tanstack/react-query';

import { FilterSchema } from '@/api';

import { useHistorischBesluitLink } from '../historischBesluit';

type HistorischBesluitLinkByLineageIdParams = {
  voorschriftLineageId: string;
};

const getHistorischBesluitLinkByLineageIdParams = ({
  voorschriftLineageId,
}: HistorischBesluitLinkByLineageIdParams) => ({
  page: 1,
  size: 1,
  filter: [
    {
      field: 'Voorschrift_lineage',
      op: 'eq',
      value: voorschriftLineageId,
    } satisfies FilterSchema,
  ],
});

const historischBesluitLinkByLineageIdOptions = ({
  voorschriftLineageId,
}: HistorischBesluitLinkByLineageIdParams) => {
  return useHistorischBesluitLink.getOptions(
    getHistorischBesluitLinkByLineageIdParams({ voorschriftLineageId }),
    {
      select: ({ objects }) => objects?.[0],
    }
  );
};

const historischBesluitLinkByLineageIdSuspenseOptions = ({
  voorschriftLineageId,
}: HistorischBesluitLinkByLineageIdParams) => {
  return useHistorischBesluitLink.getSuspenseOptions(
    getHistorischBesluitLinkByLineageIdParams({ voorschriftLineageId }),
    {
      select: ({ objects }) => objects?.[0],
    }
  );
};

const useHistorischBesluitLinkByLineageId = (
  props: HistorischBesluitLinkByLineageIdParams
) => useQuery(historischBesluitLinkByLineageIdOptions(props));
useHistorischBesluitLinkByLineageId.options =
  historischBesluitLinkByLineageIdOptions;
useHistorischBesluitLinkByLineageId.getSuspenseOptions =
  historischBesluitLinkByLineageIdSuspenseOptions;

export { useHistorischBesluitLinkByLineageId };
